import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import { DashboardMetrics, PaginatedListingSyncLogs } from "./types";

export async function getDashboardMetrics(): Promise<DashboardMetrics> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.get<DashboardMetrics>(
            `${process.env.REACT_APP_BACKEND_URL}/listing-sync/metrics`,
            { headers }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching dashboard metrics:", error);
        throw new Error("Error fetching dashboard metrics");
    }
}

export async function getPaginatedListingSyncs(
    page = 1,
    limit = 20,
    search = "",
    status = "All",
    sortBy?: string,
    sortDirection?: "asc" | "desc"
): Promise<PaginatedListingSyncLogs> {
    try {
        const headers = await getAuthHeader();

        const params: any = { page, limit, search, status };
        if (sortBy) {
            params.sortBy = sortBy;
            params.sortDirection = sortDirection || "asc";
        }

        const response = await axios.get<PaginatedListingSyncLogs>(
            `${process.env.REACT_APP_BACKEND_URL}/listing-sync/`,
            {
                params,
                headers,
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching paginated renewals:", error);
        throw new Error("Error fetching renewals");
    }
}

export async function cancelSync(
    listingSyncId: string,
    reason?: string
): Promise<void> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/listing-sync/cancel-sync`,
            { listingSyncId, reason },
            { headers }
        );

        if (response.status !== 200) {
            throw new Error("Failed to cancel renewal");
        }
    } catch (error) {
        console.error("Error canceling renewal:", error);
        throw new Error("Error canceling renewal");
    }
}

export async function getListingDetailsForSync(syncLogId: string): Promise<any> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/listing-sync/sync-details/${syncLogId}`,
            { headers }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching listing details:", error);
        throw new Error("Error fetching listing details");
    }
}
